module.exports = __webpack_public_path__ + "img/Selvy.b631ea88.jpg";